import { EnvCtx } from "@mirage/service-environment-context/global-env-ctx";
import type {
  DashMessageEvent,
  FSSMessageEvent,
} from "@mirage/service-fss-bridge/service/bridge_types";
import { tagged } from "@mirage/service-logging";
import Sentry from "@mirage/shared/sentry";
import { isDevBuildChannel } from "@mirage/shared/util/tiny-utils";
import { Config } from "../shared/config";

const logger = tagged("FSSBridgeAdapter");

export const DROPBOX_HOST =
  Config.ENV === "devbox"
    ? `https://meta-${Config.DEVBOX}.dev.corp.dropbox.com`
    : `https://www.dropbox.com`;

export interface BridgeMessageChannel {
  addListener: (listener: (message: FSSMessageEvent) => void) => void;
  postMessage: (message: DashMessageEvent) => void;
}

export function createIframeMessageChannel(
  targetWindow?: Window,
): BridgeMessageChannel {
  targetWindow = targetWindow || window;
  return {
    addListener: (listener) => {
      targetWindow.addEventListener(
        "message",
        ({ data, origin }: MessageEvent) => {
          const isDev = isDevBuildChannel(EnvCtx.buildChannel);
          if (origin !== DROPBOX_HOST && !isDev) {
            logger.warn("Received message from non-Dropbox origin", { origin });
            return;
          }

          const message = data as FSSMessageEvent;
          listener(message);
        },
      );
    },
    postMessage: (message) => {
      try {
        logger.info("Posting message to parent window", { message });
        targetWindow.parent.postMessage(message, DROPBOX_HOST);
      } catch (e) {
        logger.error("Error posting message to parent window", { error: e });
        Sentry.captureException(e);
      }
    },
  };
}
